import React,{useState,useEffect} from "react";
import Mouse from "../mouse";
import useMousePosition from "../../hooks/useMousePosition";
import socket, {  addTotalClients,
  connectedClients,
  emitMousePositions,
  removeTotalClients,
  renderMouse,
  emitRoomID
} from '../../socket';
import { debounce } from "lodash";
import { useRef } from "react";
import { useParams } from "react-router-dom";
import { useCanvas } from "../../context/canvasContext";
import {jwtDecode} from "jwt-decode";
import { getWorkWiseAuthToken, isOffline } from "../../utils/helper";

const MouseContainer = ({id}) => {
  // const  {id } = useParams();
  // ID Not being Fetched from Params Thus Using it From App.js And Passed into this comp.
  const [mousePositions, setMousePositions] = useState({
    serverX: null,
    serverY: null,
  });
  const [clientSocketID, setClientSocketID] = useState(null);
  const [connectedSocketID, setConnectedSocketID] = useState([]); // Define and initialize setConnectedSocketID
  const [numberOfConnectedClients, setNumberOfConnectedClients] = useState(0);
  const [user, setUser] = useState({});
  const { x, y, userName } = useMousePosition();

  const debouncedMousePosition = useRef(debounce((x, y, user) => {
    // emitRoomID(id)
    setClientSocketID(socket.id);
    !isOffline() && emitMousePositions({ id, x, y, userName: user.name });
  }, 250)).current;

  useEffect(() => {
    debouncedMousePosition(x, y, user);
  }, [x, y]);

  useEffect(() => {
    if (getWorkWiseAuthToken()) {
      setUser(jwtDecode(getWorkWiseAuthToken()));
    }
  }, []);


  useEffect(() => {
    renderMouse(setConnectedSocketID);
    connectedClients(setConnectedSocketID);
    addTotalClients(setNumberOfConnectedClients);
    removeTotalClients(setNumberOfConnectedClients);
  }, []);

  return (
    <>
      {connectedSocketID.map((user, index) => {
        return (
          clientSocketID !== user.clientSocketID &&
          (
            <Mouse serverX={user.x} serverY={user.y} index={index} name={user.userName} />
          )
        );
      })}
    </>
  )
};

export default MouseContainer;
